import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectPageAggQuery, {
	type ProjectPageAggQuery as ProjectPageAggQueryType,
} from '../components/ProjectPageAgg/__generated__/ProjectPageAggQuery.graphql';

export const projectPageAggResource = createRelayResource<ProjectPageAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		const isCombinedAggQueryEnabled = fg('townsquare_enable_combined_agg_query_sidebar');

		return {
			query: ProjectPageAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				searchQuery: `key = ${key} AND (archived = false OR archived = true)`,
				containerId,
				isCombinedAggQueryEnabled,
			},
		};
	},
});
